__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "mb-restaurant";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@ant-design/icons", "4.8.3", () => (Promise.all([__webpack_require__.e(292), __webpack_require__.e(333), __webpack_require__.e(995)]).then(() => (() => (__webpack_require__(90333))))));
			register("@react-google-maps/api", "2.19.3", () => (Promise.all([__webpack_require__.e(942), __webpack_require__.e(995), __webpack_require__.e(717), __webpack_require__.e(579)]).then(() => (() => (__webpack_require__(79942))))));
			register("antd", "4.24.16", () => (Promise.all([__webpack_require__.e(292), __webpack_require__.e(751), __webpack_require__.e(995), __webpack_require__.e(717), __webpack_require__.e(719)]).then(() => (() => (__webpack_require__(25751))))));
			register("lottie-react", "2.4.0", () => (Promise.all([__webpack_require__.e(750), __webpack_require__.e(995)]).then(() => (() => (__webpack_require__(93750))))));
			register("moment", "2.30.1", () => (__webpack_require__.e(178).then(() => (() => (__webpack_require__(86178))))));
			register("react-dom", "17.0.2", () => (Promise.all([__webpack_require__.e(950), __webpack_require__.e(995)]).then(() => (() => (__webpack_require__(97950))))));
			register("react-phone-input-2", "2.15.1", () => (Promise.all([__webpack_require__.e(195), __webpack_require__.e(995)]).then(() => (() => (__webpack_require__(17195))))));
			register("react-router-dom", "6.26.0", () => (Promise.all([__webpack_require__.e(245), __webpack_require__.e(995), __webpack_require__.e(717)]).then(() => (() => (__webpack_require__(53245))))));
			register("react-sortable-hoc", "2.0.0", () => (Promise.all([__webpack_require__.e(254), __webpack_require__.e(995), __webpack_require__.e(717)]).then(() => (() => (__webpack_require__(85254))))));
			register("react", "17.0.2", () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(65043))))));
			register("styled-components", "5.3.11", () => (Promise.all([__webpack_require__.e(574), __webpack_require__.e(995)]).then(() => (() => (__webpack_require__(94574))))));
			register("use-places-autocomplete", "4.0.1", () => (Promise.all([__webpack_require__.e(995), __webpack_require__.e(687)]).then(() => (() => (__webpack_require__(3687))))));
			register("web-vitals", "2.1.4", () => (__webpack_require__.e(453).then(() => (() => (__webpack_require__(46453))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};